/**
 * Field names for auto completion / autofill on browsers.
 * Refer to: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
 */
const autoComplete = {
  /**
   * An email address.
   */
  EMAIL: "email",

  /**
   * The user's current password.
   */
  PASSWORD: "current-password",

  /**
   * A new password. When creating a new account or changing passwords,
   * this should be used for an "Enter your new password" or "Confirm new password"
   * field, as opposed to a general "Enter your current password" field that might be present.
   */
  NEW_PASSWORD: "new-password",

  /**
   * The given (or "first") name.
   */
  FIRST_NAME: "given-name",

  /**
   * The family (or "last") name.
   */
  LAST_NAME: "family-name",

  /**
   * A full telephone number, including the country code.
   */
  PHONE_NUMBER: "tel",

  /**
   * The first line on the address.
   */
  STREET: "address-line1",

  /**
   * The second line on the address.
   */
  STREET_LINE2: "address-line2",

  /**
   * The first administrative level in the address.
   */
  CITY: "address-level1",

  /**
   * The second administrative level in the address.
   */
  LOCATION: "address-level2",

  /**
   * A postal code (in the United States, this is the ZIP code).
   */
  ZIP_CODE: "postal-code",

  /**
   * The address number.
   */
  NUMBER: "address-line3",

  /**
   * The currency in which the transaction is to take place.
   */
  CURRENCY_TYPE: "transaction-currency",

  /**
   * The amount, given in the currency specified by "transaction-currency",
   * of the transaction, for a payment form.
   */
  CURRENCY_AMOUNT: "transaction-amount",
};

export default autoComplete;
